module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/mastercard-mark-6d5b9983c308fc2c2d93f7d1cedb27ca.png";